// File: src/pages/Social.jsx
import React from "react";
import "../Styles/social.css";
import { FaInstagram, FaYoutube, FaSoundcloud, FaTiktok } from "react-icons/fa";


export default function Social() {
  const socials = [
    {
      id: "instagram",
      title: "Instagram",
      href: "https://www.instagram.com/dj.tlynn",
      desc: "Upcoming events, event recaps & behind-the-scenes.",
      icon: FaInstagram,
    },
    {
      id: "youtube",
      title: "YouTube",
      href: "https://www.youtube.com/@djtlynn",
      desc: "Visual mixes, recaps, and live performances.",
      icon: FaYoutube,
    }, 
    {
      id: "soundcloud",
      title: "SoundCloud",
      href: "https://soundcloud.com/dj-tlynn",
      desc: "Full DJ sets and mixes.",
      icon: FaSoundcloud,
    },
    {
      id: "tiktok",
      title: "TikTok",
      href: "https://www.tiktok.com/@dj.tlynn",
      desc: "Short clips,and music highlights.",
      icon: FaTiktok,
    }
  ];

  return (
    <div className="social-page">
      <div className="container">
        {/* Tagline moved outside of header to avoid topnav overlap */}
        <p className="tagline">
          <span className="accent">Follow, stream, and keep up with international DJ - DJ TLynn.</span> <br></br> Links open in a new tab.
        </p>

        <header className="social-header">
          <h1>Socials — DJ TLynn</h1>
        </header>

        <section className="grid-wrap" aria-label="Social links">
          {socials.map((s) => (
            <a
              key={s.id}
              className="social-card"
              href={s.href}
              target="_blank"
              rel="noreferrer"
            >
              <div className="icon-wrapper">
                <s.icon size={28} color="#66ccff" />
              </div>
              <div className="card-content media-card">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
              <div className="chev">›</div>
            </a>
          ))}

          <div className="soundcloud-card" aria-label="SoundCloud profile embed">
            <h3>SoundCloud — Full Profile</h3>
            <p className="sc-lead">Stream my full catalog and latest mixes.</p>
            <div className="sc-embed">
              <iframe
                title="SoundCloud Profile - DJ TLynn"
                width="100%"
                height="450"
                scrolling="no"
                frameBorder="no"
                allow="autoplay"
                src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(
                  "https://soundcloud.com/dj-tlynn"
                )}&amp;color=%23000000&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true&amp;visual=true`}
              ></iframe>
            </div>
          </div>
        </section>

        <footer className="footer">
        <div className="footer-inner">
          <div className="footer-columns">
            {/* Brand */}
            <div className="footer-col">
              <h3>DJ TLynn</h3>
              <p>Offering professional DJ services for unforgettable events and experiences. International DJ, DJ TLynn, speacializes in genres of Dancehall, Afrobeats, Hip-Hop and more.</p>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4>Quick Links</h4>
              <a href="/">Home</a>
              <a href="/social">Social Media</a>
              <a href="/booking">Booking</a>
              <a href="/about">About</a>
            </div>

            {/* Get In Touch */}
            <div className="footer-col">
              <h4>Get In Touch</h4>
              <p>
                <a href="tel:+15126750427" className="footer-phone" style={{color: '#fff', textDecoration: 'underline', transition: 'color 0.2s'}}>+1 (512) 815-3169</a>
              </p>
              <p>
                <span role="img" aria-label="Email"></span> <a href="mailto:bookings@djtlynn.com" className="footer-email" style={{verticalAlign: 'middle'}}>bookings@djtlynn.com</a>
              </p>
              <p>📍 Available Nationwide (Based: Austin Texas)</p>
            </div>
          </div>

          {/* Socials */}
          <div className="social-row">
            <a href="https://www.instagram.com/dj.tlynn/" aria-label="Instagram" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
              </svg>
              <span className="social-label">Instagram</span>
            </a>
            <a href="https://www.youtube.com/@DJTlynn" aria-label="YouTube" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                <rect x="2" y="4" width="20" height="16" rx="4" ry="4" />
                <polygon points="10 9 16 12 10 15 10 9" fill="currentColor" />
              </svg>
              <span className="social-label">YouTube</span>
            </a>
            <a href="https://www.tiktok.com/@dj.tlynn" aria-label="TikTok" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="social-icon">
                <path d="M9 17a4 4 0 1 1 0-8v8zm0 0V7.5A4.5 4.5 0 0 1 13.5 3H15v3.5A4.5 4.5 0 0 0 19.5 11H21" />
              </svg>
              <span className="social-label">TikTok</span>
            </a>
          </div>

          <div className="copyright">
            <p>© 2025 DJ TLynn. All rights reserved.</p>
          </div>
        </div>
      </footer>
      </div>
    </div>
  );
}